import transpose from "./transpose";

export default function() {
  return transpose(arguments);
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-array/src/zip.js
// module id = ../../../../d3-array/src/zip.js
// module chunks = 4